// **********************************************************
// Featured Offers
// **********************************************************

const featuredOffersContent = document.querySelectorAll('[data-slider="featured-offers-content"]');
const featuredOffersImage = document.querySelectorAll('[data-slider="featured-offers-image"]');

const featuredOffersImageOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  loop: true,
  effect: 'fade',
};

featuredOffersImage.forEach((el) => new Swiper(el, featuredOffersImageOptions));

const featuredOffersContentOptions = {
  slidesPerView: 1,
  spaceBetween: 100,
  speed: 800,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  autoHeight: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
    renderFraction(currentClass, totalClass) {
      return `<span class="${currentClass}"></span><span class="swiper-pagination-divider"> / </span><span class="${totalClass}"></span><span></span>`;
    },
    formatFractionCurrent(number) {
      return (number < 10 ? '0' : '') + number;
    },
    formatFractionTotal(number) {
      return (number < 10 ? '0' : '') + number;
    },
  },
  breakpoints: {
    1023: {
      spaceBetween: 180,
    },
  },
};

featuredOffersContent.forEach((el) => {
  const featuredOffers = el.closest('.featured-offers');
  const arrowRight = featuredOffers.querySelector('.swiper-button-next');
  const arrowLeft = featuredOffers.querySelector('.swiper-button-prev');
  const paginationElement = featuredOffers.querySelector('.swiper-pagination');

  featuredOffersContentOptions.navigation.nextEl = arrowRight;
  featuredOffersContentOptions.navigation.prevEl = arrowLeft;
  featuredOffersContentOptions.pagination.el = paginationElement;

  const featuredOffersImage = featuredOffers.querySelector('[data-slider="featured-offers-image"]');
  const imageSlider = featuredOffersImage.swiper;

  const contentSlider = new Swiper(el, featuredOffersContentOptions);

  imageSlider.controller.control = contentSlider;
  contentSlider.controller.control = imageSlider;
});

// Mouse Hover

const featuredOffers = document.querySelectorAll('.featured-offers');

featuredOffers.forEach((ele) => {
  const cursor = ele.querySelector('.featured-offers__cursor');

  if (cursor) {
    const cursorWrapper = ele.querySelector('.featured-offers__image-slider-inner');

    const moveCursor = (e) => {
      const rect = cursorWrapper.getBoundingClientRect();
      const offset = 0;

      const relX = Math.min(Math.max(e.clientX - rect.left, offset), rect.width - cursor.offsetWidth - offset);
      const relY = Math.min(Math.max(e.clientY - rect.top, offset), rect.height - cursor.offsetHeight - offset);

      cursor.style.left = `${relX}px`;
      cursor.style.top = `${relY}px`;

      gsap.to(cursor, 0.4, { scale: 1, autoAlpha: 1 });
    };

    cursorWrapper.addEventListener('mouseenter', () => {
      gsap.to(cursor, 0.4, { scale: 1, autoAlpha: 1 });
      cursorWrapper.addEventListener('mousemove', moveCursor);
    });

    cursorWrapper.addEventListener('mouseleave', () => {
      gsap.to(cursor, 0.4, { scale: 0.5, autoAlpha: 0 });
      cursorWrapper.removeEventListener('mousemove', moveCursor);
    });
  }
});
